// extracted by mini-css-extract-plugin
export default {"searchContainer":"Search_searchContainer__4XCM3","searchBox":"Search_searchBox__Z9rHJ","searchInput":"Search_searchInput__WyteM","boton":"Search_boton__FcoAy"};